import {
  MicroNavigatorProvider,
  PageItem,
} from "../../../common/components/organisme/MicroNavigator/MicroNavigatorContext";
import CreateLinkPage from "./CreateLinkPage/CreateLinkPage";
import EditLinkPage from "./EditLinkPage/EditLinkPage";
import LinkListPage from "./LinkListPage/LinkListPage";
import SingleLinkPage from "./SingleLinkPage/SingleLinkPage";
import { RequireCapability } from "../../../features/rbac";

export default function LinkPages() {
  return (
    <MicroNavigatorProvider>
      <PageItem
        name="LinkListPage"
        path="list"
        PageRender={() => <LinkListPage />}
        isDefault
      />
      <PageItem
        name={"SinglePage"}
        path="single"
        PageRender={() => <SingleLinkPage />}
      />
      <PageItem
        name={"Edit"}
        path="edit"
        PageRender={() => <RequireCapability capability="planbt.edit"><EditLinkPage /></RequireCapability>}
      />
      <PageItem
        name={"Create"}
        path="create"
        PageRender={() => <RequireCapability capability="planbt.edit"><CreateLinkPage /></RequireCapability>}
      />
    </MicroNavigatorProvider>
  );
}
